import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type QuizPreviousResult = paths['/quiz/{slug}/results/{uuid}/'];

const getQuizPreviousResult = createRequest<QuizPreviousResult>('/pc/quiz/{slug}/results/{uuid}/');

export default getQuizPreviousResult;
